"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dcOasisPayloadToFormDataHandler = dcOasisPayloadToFormDataHandler;
function dcOasisPayloadToFormDataHandler(data) {
    return {
        visitDate: data.form.visitDate,
        nameOfPersonSpokenTo: data.form.nameOfPersonSpokenTo || "N/A",
        withVisit: data.form.withVisit,
        informedPhysician: data.form.informedPhysician,
        notes: data.form.comments || "",
    };
}
